import React, { Component } from 'react';

import Button from 'components/Core/Button/index';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import TextField from 'components/Core/TextField/index';
import DatePicker from 'components/Core/DatePicker/index';
import TimePicker from 'components/Core/TimePicker/index';
import Select from 'components/Core/Select/index';
import Checkbox from 'components/Core/Checkbox/index';

import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import unionWith from 'lodash/unionWith';

import AppConfigService from 'services/AppConfigService';

import ClientRequestService from 'services/ClientRequestService';
import './DataTableComponent.css';

import axios from 'axios';


const ModelState = {
    Added: 'Added',
    Modified: 'Modified',
    Deleted: 'Deleted',
    Unchanged: 'Unchanged',
    Detached: 'Detached',
    Archived: 'Archived'
};


export default class DataTableComponent extends Component {
    constructor(props) {
        super(props);

        let tableConfig = { ...this.defaultTableProps, ...props.tableConfig };
        if (!tableConfig.filters) tableConfig.filters = {};
        if (tableConfig.template) {
            tableConfig.template.filter(col => col.filter).forEach(col => {
                tableConfig.filters[col.field] = { value: '' }
            });
        }

        let subTableConfig = { ...this.defaultTableProps, ...props.subTableConfig };
        if (!subTableConfig.filters) subTableConfig.filters = {};
        if (subTableConfig.template) {
            subTableConfig.template.filter(col => col.filter).forEach(col => {
                subTableConfig.filters[col.field] = { value: '' }
            });
        }

        let dataSourceConfig = props.dataSourceConfig;

        if (!dataSourceConfig.dataLoaderFilterer) {
            dataSourceConfig.dataLoaderFilterer =
            {
                'SortName': tableConfig.template[0].field,
                'SortOrder': 'ASC'
            }
        }

        const { module, lazyRequestInterval } = props;

        this.state = {
            parentDataSource: [],
            childrenDataSource: [],
            parentKey: 'parentKey',
            childKey: 'childKey',
            linker: 'key',
            expandedRows: null,
            controller: dataSourceConfig.controller,
            dataLoader: dataSourceConfig.dataLoader,
            dataLoaderFilterer: dataSourceConfig.dataLoaderFilterer,
            extraParameter: dataSourceConfig.extraParameter || {},
            formatterLoader: dataSourceConfig.formatterLoader,
            formatterLoaderFilterer: dataSourceConfig.formatterLoaderFilterer,
            formatters: [{ date: 'dd/mm/yy' }],
            comboLoaderController: dataSourceConfig.comboLoaderController,
            comboLoader: dataSourceConfig.comboLoader,
            comboLoaderFilterer: dataSourceConfig.comboLoaderFilterer,
            comboSources: [],

            tableConfig: tableConfig,
            subTableConfig: subTableConfig,

            selectedParent: null,
            selectedChild: null,

            lazyRequestInterval: lazyRequestInterval ? lazyRequestInterval : 500
        };

        this.dateFormat = new AppConfigService().getDateFormat();

        this.dataHandlerService = new ClientRequestService(module);

        this.parentKeyInitializer = 300000;
        this.childKeyInitializer = 300000;

        this.childrenTables = {};
        this.parentFilters = tableConfig.filters;

        this.parentTable = React.createRef();
    }

    getParentRowIndexByRowData = (rowData) => {
        return this.state.parentDataSource.indexOf(rowData);
    }

    setParentRowDataByRowIndex = (rowData, rowIndex) => {
        let updatingParentDataSource = this.state.parentDataSource;
        updatingParentDataSource[rowIndex] = rowData;
        this.setState({ parentDataSource: updatingParentDataSource });
    }

    setGridLayoutTemplate = (template) => {
        return new Promise(resolve => {
            this.setState({ tableConfig: { ...this.state.tableConfig, template: template } }, () => resolve());
        });
    }

    setGridCellEditable = (field, editable) => {
        let updatingTableConfig = this.state.tableConfig;
        if (!(field instanceof Array)) {
            field = [field];
        }

        let changingCol = updatingTableConfig.template.filter(col => field.includes(col.field));

        if (changingCol) {
            changingCol.forEach(col => {
                let changingColIndex = updatingTableConfig.template.indexOf(col);
                col.editable = editable;
                updatingTableConfig.template[changingColIndex] = col;
            });

            this.setState({ tableConfig: updatingTableConfig });
        }
    }

    setGridCellType = (field, type) => {
        let updatingTableConfig = this.state.tableConfig;
        if (!(field instanceof Array)) {
            field = [field];
        }

        let changingCol = updatingTableConfig.template.filter(col => field.includes(col.field));

        if (changingCol) {
            changingCol.forEach(col => {
                let changingColIndex = updatingTableConfig.template.indexOf(col);
                col.type = type;
                updatingTableConfig.template[changingColIndex] = col;
            });

            this.setState({ tableConfig: updatingTableConfig });
        }
    }

    setCellValue = (rowIndex, field, value, subGrid) => {
        if (!subGrid) {
            let updatingParentDataSource = this.state.parentDataSource;
            updatingParentDataSource[rowIndex][field] = value;

            this.setState({ parentDataSource: updatingParentDataSource });
        }
    }

    setParentSelection = (selection) => {
        this.setState({ selectedParent: selection });
    }

    getParentSelection = () => {
        return this.state.selectedParent;
    }

    setChildrenSelection = (selection) => {
        this.setState({ selectedChild: selection });
    }

    getChildrenSelection = () => {
        return this.state.selectedChild;
    }

    clearData = () => {
        this.parentKeyInitializer = 300000;
        this.childKeyInitializer = 300000;
        this.childrenTables = {};

        this.setState({
            parentDataSource: [],
            childrenDataSource: [],
            selectedParent: null,
            selectedChild: null
        });
    }

    setDataLoaderParameters(parameter) {
        return new Promise(resolve => {
            this.setState({ extraParameter: parameter }, () => resolve());
        });
    }

    //#region Component mount
    bindState = (formatters, comboSources, dataSource, event) => {
        if (formatters) {
            this.setState({ formatters: formatters });
        }

        if (comboSources) {
            this.setState({ comboSources: comboSources });
        }

        this.setData(dataSource, event);
    }

    setData(dataSource, event) {
        if (dataSource) {
            this.setState({
                parentDataSource: dataSource.parentDataSource.Rows ? dataSource.parentDataSource.Rows : dataSource.parentDataSource,
                tableConfig: dataSource.parentDataSource.Rows ? { ...this.state.tableConfig, loading: false, totalRecords: dataSource.parentDataSource.Total, first: event ? event.first : 0 } : { ...this.state.tableConfig, totalRecords: dataSource.parentDataSource.length },
                childrenDataSource: dataSource.childrenDataSource,
                parentKey: dataSource.parentKey,
                childKey: dataSource.childKey,
                linker: dataSource.linker,
                selectedParent: null,
                selectedChild: null
            });

            if (this.state.subTableConfig.template) {
                this.childKeyPos = this.state.subTableConfig.template.map(col => col.field).indexOf(this.state.childKey);
            }
        }
    }

    loadData(loadCallback) {
        var that = this;
        const pagingConfig = {
            Offset: 0,
            Limit: this.state.tableConfig.rows,
            ServerPagination: this.state.tableConfig.lazy
        };

        let parameters = [];

        if (this.state.extraParameter instanceof Array) {
            this.state.extraParameter.forEach(param => {
                parameters.push(param);
            });
        } else {
            Object.keys(this.state.extraParameter).forEach(key => {
                parameters.push({ name: key, operat: '=', value: this.state.extraParameter[key] });
            });
        }

        let loaderPostData =
        {
            ...this.state.dataLoaderFilterer, ...pagingConfig, Parameters: parameters
        };

        axios.all([
            this.state.formatterLoader &&
            this.dataHandlerService.Post(
                {
                    url: `${this.state.controller}/${this.state.formatterLoader}`,
                    withModule: false,
                    data: this.state.formatterLoaderFilterer
                }),
            this.state.comboLoader &&
            this.dataHandlerService.Get(
                {
                    url: `${this.state.comboLoaderController ? this.state.comboLoaderController : this.state.controller}/${this.state.comboLoader}`,
                    withModule: false
                }
            ),
            this.dataHandlerService.Post(
                {
                    url: `${this.state.controller}/${this.state.dataLoader}`,
                    withModule: false,
                    data: loaderPostData
                }
            )
        ]).then(axios.spread(function (formatters, comboSources, dataSource) {
            that.bindState(
                formatters ? formatters : that.state.formatters,
                comboSources ? comboSources : that.state.comboSources,
                dataSource ? dataSource : that.state.dataSource
            );

            if (typeof (loadCallback) === 'function') {
                loadCallback(dataSource);
            }
        }));
    }

    loadDataWithServerSidePagination(event, loadCallback) {
        var that = this;

        const pagingConfig = { Offset: event.first, Limit: event.first + event.rows, ServerPagination: true };
        const sortingConfig = {
            SortName: event.SortName ? event.SortName : this.state.dataLoaderFilterer.SortName,
            SortOrder: event.SortOrder ? (event.SortOrder === 1 ? 'ASC' : 'DESC') : this.state.dataLoaderFilterer.SortOrder
        };

        let parameters = [];
        if (this.state.extraParameter instanceof Array) {
            this.state.extraParameter.forEach(param => {
                parameters.push(param);
            });
        } else {
            Object.keys(this.state.extraParameter).forEach(key => {
                parameters.push({ name: key, operat: '=', value: this.state.extraParameter[key] });
            });
        }

        Object
            .keys(this.parentFilters)
            .filter(key => {
                return this.parentFilters[key].value
            })
            .reduce((obj, key) => {
                parameters.push({ name: key, operat: 'cn', value: this.parentFilters[key].value });
                return obj;
            }, {});

        let loaderPostData =
        {
            ...this.state.dataLoaderFilterer, ...pagingConfig, ...sortingConfig, Parameters: parameters
        };

        axios.all([
            this.state.formatterLoader &&
            this.dataHandlerService.Post(
                {
                    url: `${this.state.controller}/${this.state.formatterLoader}`,
                    withModule: false,
                    data: this.state.formatterLoaderFilterer
                }),
            this.state.comboLoader &&
            this.dataHandlerService.Get(
                {
                    url: `${this.state.comboLoaderController ? this.state.comboLoaderController : this.state.controller}/${this.state.comboLoader}`,
                    withModule: false
                }
            ),
            this.dataHandlerService.Post(
                {
                    url: `${this.state.controller}/${this.state.dataLoader}`,
                    withModule: false,
                    data: loaderPostData
                }
            )
        ]).then(axios.spread(function (formatters, comboSources, dataSource) {
            that.bindState(
                formatters ? formatters : that.state.formatters,
                comboSources ? comboSources : that.state.comboSources,
                dataSource ? dataSource : that.state.dataSource,
                event
            );

            if (typeof (loadCallback) === 'function') {
                loadCallback(dataSource);
            }
        }));
    }

    componentDidMount() {
        this.loadData();
    }

    getGridCellRenderer(type) {
        switch (type) {
            case 'text':
                return this.gridTextFieldEditor;
            case 'int':
                return this.gridIntegerEditor;
            case 'dec':
                return this.gridDecimalEditor;
            case 'checkbox':
                return this.gridCheckboxEditor;
            case 'date':
                return this.gridDateEditor;
            case 'time':
                return this.gridTimeEditor;
            case 'combo':
                return this.gridComboEditor;
            case 'btn':
                return this.gridButton;
            default:
                return this.gridTextFieldEditor;
        }
    }

    getPaginatorLeft = (footerOf, subLinker = '') => {
        const { showAdd, showDelete, showRefresh, showRestore, additionalFooter, paginatorLeft } = (footerOf === 'table' ? this.state.tableConfig : this.state.subTableConfig);

        const footer =
            <div className='p-clearfix' style={{ width: '100%' }} sublinker={subLinker}>
                <Button style={{ float: 'left', display: (showAdd ? 'block' : 'none') }} icon='pi pi-plus' onClick={footerOf === 'table' ? this.addTableRow : this.addSubTableRow} />
                <Button style={{ float: 'left', display: (showDelete ? 'block' : 'none') }} icon='pi pi-trash' onClick={footerOf === 'table' ? this.deleteTableRow : this.deleteSubTableRow} />
                <Button style={{ float: 'left', display: (showRestore ? 'block' : 'none') }} icon='pi pi-replay' onClick={footerOf === 'table' ? this.restoreTableRow : this.restoreSubTableRow} />
                <Button style={{ float: 'left', display: (showRefresh ? 'block' : 'none') }} icon='pi pi-refresh' onClick={footerOf === 'table' ? this.refreshTable : this.refreshSubTableRow} />

                {additionalFooter}
                {paginatorLeft}
            </div>;

        return footer;
    }

    //#endregion

    //#region Grid
    onGridEditorValueChange(props, value) {
        const updatingParentDataSource = unionWith(
            cloneDeep(this.state.parentDataSource),
            cloneDeep(props.value),
            isEqual
        );

        const updatingRowIndex = this.state.parentDataSource.indexOf(props.rowData);

        // const updatingParentDataSource = [...props.value];
        updatingParentDataSource[updatingRowIndex][props.field] = (value !== null || value !== undefined) ? value : updatingParentDataSource[updatingRowIndex][props.field];

        switch (updatingParentDataSource[updatingRowIndex]['ModelState']) {
            case ModelState.Deleted:
            case ModelState.Modified:
            case ModelState.Added:
                break;
            default:
                updatingParentDataSource[updatingRowIndex]['ModelState'] = ModelState.Modified;
                break;
        }

        this.setState({ parentDataSource: updatingParentDataSource });
    }

    simulateTDClick = (event) => {
        event.target.parentNode.parentNode.parentNode.click();
    }

    onGridCellValueChange = (e, colProps) => {
        colProps.onChange(e, colProps).then(({ value, colProps }) => {
            this.onGridEditorValueChange(colProps, value);
        });
    }

    onGridCellCheckChange = (e, colProps, rowData) => {
        colProps.onChange(e, colProps, rowData).then(({ checked, colProps }) => {
            this.onGridEditorValueChange(colProps, checked);
        });
    }

    onGridButtonClick = (e, colProps) => {
        colProps.onClick(e, colProps).then(({ e, colProps }) => {
            this.onGridEditorValueChange(colProps, null);
        });
    }

    gridCheckboxEditor = (rowData, colProps) => {
        return <Checkbox checked={rowData[colProps.field]} onChange={
            (e) => {
                if (colProps.onChange) {
                    this.onGridCellCheckChange(e, colProps, rowData);
                } else {
                    this.onGridEditorValueChange(colProps, e.target.checked);
                }
            }
        } disabled={colProps.readonly} inputProps={{ style: colProps.style }} />;
    }

    gridButton = (rowData, colProps) => {
        return <Button icon={`pi pi-${colProps.icon}`} className={`btn-grid-${colProps.icon}`} onClick={
            (e) => {
                if (typeof (colProps.onClick) === 'function') {
                    this.onGridButtonClick(e, colProps);
                }
            }
        } disabled={colProps.disabled} InputProps={{ disableUnderline: colProps.disableUnderline, readOnly: colProps.readonly }} inputProps={{ style: colProps.style }} />;
    }

    gridTextFieldEditor = (rowData, colProps) => {
        return <TextField type='text' onClick={this.simulateTDClick} value={rowData[colProps.field] ? rowData[colProps.field] : ''} onChange={
            (e) => {
                if (colProps.onChange) {
                    this.onGridCellValueChange(e, colProps);
                } else {
                    this.onGridEditorValueChange(colProps, e.target.value);
                }
            }
        } disabled={colProps.disabled} InputProps={{ disableUnderline: colProps.disableUnderline, readOnly: colProps.readonly }} inputProps={{ style: colProps.style, onBlur: colProps.editorValidatorEvent === 'blur' && typeof colProps.editorValidator === 'function' ? colProps.editorValidator.bind(null, colProps) : undefined }} />;
    }

    gridIntegerEditor = (rowData, colProps) => {
        return <TextField type='number' onClick={this.simulateTDClick} value={rowData[colProps.field] ? rowData[colProps.field] : ''} onChange={
            (e) => {
                if (colProps.onChange) {
                    this.onGridCellValueChange(e, colProps);
                } else {
                    this.onGridEditorValueChange(colProps, e.target.value);
                }
            }
        } disabled={colProps.disabled} InputProps={{ disableUnderline: colProps.disableUnderline, readOnly: colProps.readonly }} inputProps={{ style: colProps.style, onBlur: colProps.editorValidatorEvent === 'blur' && typeof colProps.editorValidator === 'function' ? colProps.editorValidator.bind(null, colProps) : undefined }} />;
    }

    gridDecimalEditor = (rowData, colProps) => {
        return <TextField type='number' onClick={this.simulateTDClick} value={rowData[colProps.field] ? rowData[colProps.field] : ''} onChange={
            (e) => {
                if (colProps.onChange) {
                    this.onGridCellValueChange(e, colProps);
                } else {
                    this.onGridEditorValueChange(colProps, e.target.value);
                }
            }
        } disabled={colProps.disabled} InputProps={{ disableUnderline: colProps.disableUnderline, readOnly: colProps.readonly }} inputProps={{ style: colProps.style, onBlur: colProps.editorValidatorEvent === 'blur' && typeof colProps.editorValidator === 'function' ? colProps.editorValidator.bind(null, colProps) : undefined }} />;
    }

    gridComboEditor = (rowData, colProps) => {
        let url = colProps.loader.dependsOn ? colProps.loader.url + '/' + (colProps.rowData[colProps.loader.dependsOn] ? colProps.rowData[colProps.loader.dependsOn] : -1) : colProps.loader.url;

        return (
            <Select rowIndex={colProps.rowIndex} onClick={this.simulateTDClick} url={url} withModule={colProps.loader.withModule} options={colProps.loader.options} value={rowData[colProps.field]} mapper={colProps.loader.mapper} onChange={
                (e) => {
                    if (colProps.onChange) {
                        this.onGridCellValueChange(e, colProps);
                    } else {
                        this.onGridEditorValueChange(colProps, e.target.value);
                    }
                }
            } loadComplete={colProps.loader.loadComplete} disabled={colProps.readonly} />
        );
    }

    onGridCellDateTimeChange = (dateTimeValue, colProps) => {
        colProps.onChange(dateTimeValue, colProps).then(({ dateTimeValue, colProps }) => {
            this.onGridEditorValueChange(colProps, dateTimeValue);
        });
    }

    gridDateEditor = (rowData, colProps) => {
        return (
            <DatePicker
                invalidDateMessage={null}
                onClick={this.simulateTDClick}
                value={rowData[colProps.field]}
                onChange={
                    (dateValue) => {
                        if (colProps.onChange) {
                            this.onGridCellDateTimeChange(dateValue, colProps);
                        } else {
                            this.onGridEditorValueChange(colProps, dateValue);
                        }
                    }
                }
                disabled={colProps.readonly}
                InputProps={{ disableUnderline: colProps.disableUnderline, readOnly: colProps.readonly }}
                inputProps={{ style: colProps.style, onBlur: colProps.editorValidatorEvent === 'blur' && typeof colProps.editorValidator === 'function' ? colProps.editorValidator.bind(null, colProps) : undefined }}
                format={this.dateFormat} />
        );
    }

    gridTimeEditor = (rowData, colProps) => {
        return (
            <TimePicker
                invalidDateMessage={null}
                onClick={this.simulateTDClick}
                value={rowData[colProps.field]}
                onChange={
                    (timeValue) => {
                        if (colProps.onChange) {
                            this.onGridCellDateTimeChange(timeValue, colProps);
                        } else {
                            this.onGridEditorValueChange(colProps, timeValue);
                        }
                    }
                }
                disabled={colProps.readonly}
                InputProps={{ disableUnderline: colProps.disableUnderline, readOnly: colProps.readonly }}
                inputProps={{ style: colProps.style, onBlur: colProps.editorValidatorEvent === 'blur' && typeof colProps.editorValidator === 'function' ? colProps.editorValidator.bind(null, colProps) : undefined }} />
        );
    }

    onParentRowExpansion() { }

    parentRowClassName(rowData) {
        const rowEditorStatus = rowData.ModelState;
        const isDeleted = (rowEditorStatus === ModelState.Deleted);
        return isDeleted ? { 'deleted-row': true } : { 'restored-row': true };
    }

    onParentPage = (event) => {
        this.setState({
            tableConfig: {
                ...this.state.tableConfig, loading: true, rows: event.rows
            }
        });

        const { sortField, sortOrder } = this.parentTable.current.props;

        this.loadDataWithServerSidePagination({ ...event, SortName: sortField, SortOrder: sortOrder });
    }

    onParentSort = (event) => {
        this.setState({
            tableConfig: { ...this.state.tableConfig, sortField: event.sortField, sortOrder: event.sortOrder }
        }, () => {
            this.onParentPage({
                rows: this.parentTable.current.props.rows,
                first: this.parentTable.current.props.first
            });
        });
    }

    onParentFilter = (event) => {
        const eventFilters = event.filters;
        const currentFilter = Object
            .keys(eventFilters)
            .filter(key => {
                return eventFilters[key].value
            })
            .reduce((obj, key) => {
                obj[key] = eventFilters[key];
                return obj;
            }, {});

        this.parentFilters = Object
            .keys(this.parentFilters)
            .filter(key => {
                return Object.keys(eventFilters).includes(key);
            })
            .reduce((obj, key) => {
                obj[key] = this.parentFilters[key];
                return obj;
            }, {});

        this.parentFilters = { ...this.parentFilters, ...currentFilter };

        if (this.state.lazyRequestTimerID) {
            clearTimeout(this.state.lazyRequestTimerID);
        }

        var lazyRequestTimerID = setTimeout(() => {
            this.onParentPage({
                rows: this.parentTable.current.props.rows,
                first: this.parentTable.current.props.first
            });
        }, this.state.lazyRequestInterval);

        this.setState({ lazyRequestTimerID });
    }

    render() {
        const dynamicColumns = this.state.tableConfig.template.map((col) => {
            const colConf = { ...this.defaultColumnProps, ...col, editable: col.editable || (col.editable === undefined && this.state.tableConfig.editable) ? true : false };

            return <Column columnKey={colConf.columnKey} field={colConf.field} sortField={colConf.sortField} header={colConf.header} body={this.getGridCellRenderer(colConf.type)} loadingBody={colConf.loadingBody} footer={colConf.footer} sortable={colConf.sortable} sortFunction={colConf.sortFunction} filter={colConf.filter} filterMatchMode={colConf.filterMatchMode} filterPlaceholder={colConf.filterPlaceholder} filterType={colConf.filterType} filterMaxLength={colConf.filterMaxLength} filterElement={colConf.filterElement} filterFunction={colConf.filterFunction} style={colConf.style ? colConf.style : {}} className={colConf.className} headerStyle={colConf.headerStyle} headerClassName={colConf.headerClassName} bodyStyle={colConf.bodyStyle} bodyClassName={colConf.bodyClassName} footerStyle={colConf.footerStyle} footerClassName={colConf.footerClassName} expander={colConf.expander} frozen={colConf.frozen} selectionMode={colConf.selectionMode} colSpan={colConf.colSpan} rowSpan={colConf.rowSpan} editor={colConf.editor} editorValidator={colConf.editorValidator} editorValidatorEvent={colConf.editorValidatorEvent} onEditorSubmit={colConf.onEditorSubmit} onEditorCancel={colConf.onEditorCancel} excludeGlobalFilter={colConf.excludeGlobalFilter} rowReorder={colConf.rowReorder} rowReorderIcon={colConf.rowReorderIcon} key={colConf.field} customData={colConf.customData} loader={colConf.loader} disableUnderline={colConf.disableUnderline} readonly={!colConf.editable} onChange={colConf.onChange} onClick={colConf.onClick} icon={colConf.icon} />;
        });

        const {
            id, header, footer, style, className, tableStyle, tableClassName, paginator, paginatorPosition,
            alwaysShowPaginator, paginatorTemplate, additionalFooter, showAdd, showDelete, showRefresh, showRestore,
            paginatorRight, pageLinkSize, rowsPerPageOptions, currentPageReportTemplate, first, rows, totalRecords,
            lazy, sortField, sortOrder, multiSortMeta, sortMode, defaultSortOrder, emptyMessage, selectionMode, selection, onSelectionChange, contextMenuSelection, onContextMenuSelectionChange, compareSelectionBy, metaKeySelection, headerColumnGroup, footerColumnGroup, frozenHeaderColumnGroup, frozenFooterColumnGroup, responsive, resizableColumns, columnResizeMode, reorderableColumns, filters, globalFilter, scrollable, scrollHeight, virtualScroll, virtualScrollDelay,
            virtualRowHeight, frozenWidth, frozenValue, csvSeparator, exportFilename, rowGroupMode, autoLayout,
            rowClassName, rowGroupHeaderTemplate, rowGroupFooterTemplate, loading, loadingIcon, tabIndex, stateKey, stateStorage,
            onColumnResizeEnd, onVirtualScroll, onRowClick, onRowDoubleClick, onRowSelect, onRowExpand,
            onRowCollapse, onContextMenu, onColReorder, onRowReorder, onValueChange, editable, rowSelector, multiSelect
        } = this.state.tableConfig;

        return (
            <div style={{ width: '100%' }}>
                <div className='content-section implementation'>
                    <DataTable ref={this.parentTable} id={id} value={this.state.parentDataSource} header={header} footer={footer} style={style} className={className} tableStyle={tableStyle} tableClassName={tableClassName} paginator={paginator} paginatorPosition={paginatorPosition} alwaysShowPaginator={alwaysShowPaginator} paginatorTemplate={paginatorTemplate} paginatorLeft={(additionalFooter || showAdd || showDelete || showRefresh || showRestore) && this.getPaginatorLeft('table')} paginatorRight={paginatorRight} pageLinkSize={pageLinkSize} rowsPerPageOptions={rowsPerPageOptions} currentPageReportTemplate={currentPageReportTemplate} first={first} rows={rows} totalRecords={totalRecords} lazy={lazy} sortField={sortField} sortOrder={sortOrder} multiSortMeta={multiSortMeta} sortMode={sortMode} defaultSortOrder={defaultSortOrder} emptyMessage={emptyMessage}
                        {...((rowSelector || multiSelect) ? {} : (selectionMode ? { selectionMode: selectionMode } : {}))}
                        selection={selection ? selection : this.state.selectedParent} onSelectionChange={(e) => {
                            this.setState({ selectedParent: e.value });
                            if (onSelectionChange) onSelectionChange(e);
                        }} contextMenuSelection={contextMenuSelection} onContextMenuSelectionChange={onContextMenuSelectionChange} compareSelectionBy={compareSelectionBy} dataKey={this.state.parentKey} metaKeySelection={metaKeySelection} headerColumnGroup={headerColumnGroup} footerColumnGroup={footerColumnGroup} frozenHeaderColumnGroup={frozenHeaderColumnGroup} frozenFooterColumnGroup={frozenFooterColumnGroup} rowExpansionTemplate={this.renderChildren} expandedRows={this.state.expandedRows} onRowToggle={(e) => this.setState({ expandedRows: e.data })} responsive={responsive} resizableColumns={resizableColumns} columnResizeMode={columnResizeMode} reorderableColumns={reorderableColumns} filters={filters} globalFilter={globalFilter} scrollable={scrollable} scrollHeight={scrollHeight} virtualScroll={virtualScroll} virtualScrollDelay={virtualScrollDelay} virtualRowHeight={virtualRowHeight} frozenWidth={frozenWidth} frozenValue={frozenValue} csvSeparator={csvSeparator} exportFilename={exportFilename} rowGroupMode={rowGroupMode} autoLayout={autoLayout} rowClassName={rowClassName ? rowClassName : this.parentRowClassName} rowGroupHeaderTemplate={rowGroupHeaderTemplate} rowGroupFooterTemplate={rowGroupFooterTemplate} loading={loading} loadingIcon={loadingIcon} tabIndex={tabIndex} stateKey={stateKey} stateStorage={stateStorage} onColumnResizeEnd={onColumnResizeEnd} onSort={lazy ? this.onParentSort : null} onPage={lazy ? this.onParentPage : null} onFilter={lazy ? this.onParentFilter : null} onVirtualScroll={onVirtualScroll} onRowClick={onRowClick} onRowDoubleClick={onRowDoubleClick} onRowSelect={onRowSelect} onRowExpand={onRowExpand ? onRowExpand : this.onParentRowExpansion} onRowCollapse={onRowCollapse} onContextMenu={onContextMenu} onColReorder={onColReorder} onRowReorder={onRowReorder} onValueChange={onValueChange} editable={editable}  >
                        {
                            (rowSelector || multiSelect) &&
                            <Column selectionMode={multiSelect ? 'multiple' : 'single'} style={{ width: '3em' }} />
                        }
                        {
                            this.state.subTableConfig.template &&
                            <Column expander={true} style={{ width: '3em', textAlign: 'center' }} />
                        }
                        {dynamicColumns}
                        <Column field='ModelState' style={{ display: 'none' }} />
                        <Column field='RowVersion' style={{ display: 'none' }} />
                    </DataTable>
                </div>
            </div>
        );
    }

    //#region CRUD    
    addTableRowWithRowData = (newTableRow) => {
        if (!this.state.tableConfig.editable) return false;

        newTableRow['ModelState'] = ModelState.Added;

        const parentDataSource = this.state.parentDataSource;

        parentDataSource.push(newTableRow);
        this.setState({ parentDataSource: parentDataSource });
    }

    addTableRow = () => {
        if (!this.state.tableConfig.editable) return false;

        var that = this;
        let newTableRow = {};

        this.state.tableConfig.template.map(col => [col.field, col.type]).forEach(function (mapped) {
            switch (mapped[1]) {
                case 'int':
                case 'dec':
                    newTableRow[mapped[0]] = 0;
                    break;
                case 'combo':
                case 'text':
                    newTableRow[mapped[0]] = '';
                    break;
                case 'checkbox':
                    newTableRow[mapped[0]] = false;
                    break;
                case 'date':
                case 'time':
                    newTableRow[mapped[0]] = null;
                    break;
                default:
                    newTableRow[mapped[0]] = '';
                    break;
            }

            if (mapped[0] === that.state.parentKey) {
                newTableRow[mapped[0]] = that.parentKeyInitializer++;
            }
        });

        newTableRow['ModelState'] = ModelState.Added;

        const parentDataSource = this.state.parentDataSource;

        if (typeof (this.state.tableConfig.onRowAdded) === 'function') {
            Promise.resolve(this.state.tableConfig.onRowAdded(newTableRow)).then(
                (rowData) => {
                    newTableRow = rowData;
                    if (newTableRow) {
                        parentDataSource.push(newTableRow);
                        this.setState({ parentDataSource: parentDataSource });
                    }
                }
            );
        } else {
            parentDataSource.push(newTableRow);
            this.setState({ parentDataSource: parentDataSource });
        }
    }

    findSelectedParentIndex(selectedParent) {
        return this.state.parentDataSource.indexOf(selectedParent);
    }

    deleteCorrespondingChildren(linkerVal) {
        this.state.childrenDataSource && this.state.childrenDataSource.filter(
            child => child[this.state.linker].toString() === linkerVal.toString()
        ).forEach(deletingChild => deletingChild.ModelState = ModelState.Deleted);
    }

    restoreCorrespondingChildren(linkerVal) {
        var that = this;
        this.state.childrenDataSource && this.state.childrenDataSource.filter(
            child => child[this.state.linker].toString() === linkerVal.toString()
        ).forEach(deletingChild => {
            if (that.checkDeletedStatus(deletingChild.ModelState)) {
                deletingChild.ModelState = ModelState.Modified;
            }
        });
    }

    deleteTableRowMain = (selectedParent) => {
        const that = this;
        const index = this.findSelectedParentIndex(selectedParent);
        const parentDataSource = that.state.parentDataSource;

        switch (selectedParent['ModelState']) {
            case ModelState.Deleted:
                break;
            case ModelState.Added:
                this.setState({
                    parentDataSource: that.state.parentDataSource.filter((val, i) => i !== index),
                    selectedParent: null
                });

                break;
            case ModelState.Modified:
                selectedParent['ModelState'] = ModelState.Deleted;
                parentDataSource[index] = selectedParent;

                // that.parentTable.current.table.rows[deletingIndex].style.color = 'red';
                this.setState({
                    parentDataSource: parentDataSource
                });

                this.deleteCorrespondingChildren(selectedParent[this.state.linker]);

                break;
            default:
                selectedParent['ModelState'] = ModelState.Deleted;
                parentDataSource[index] = selectedParent;

                // that.parentTable.current.table.rows[deletingIndex].style.color = 'red';

                this.setState({
                    parentDataSource: parentDataSource
                });

                this.deleteCorrespondingChildren(selectedParent[this.state.linker]);

                break;
        }
    }

    deleteTableRow = () => {
        if (!this.state.tableConfig.editable) return false;

        if (!this.state.selectedParent) return;

        let selectedParent = this.state.selectedParent;

        if (typeof (this.state.tableConfig.onRowDeleted) === 'function') {
            if (this.state.tableConfig.onRowDeleted(selectedParent) === false) return false;
        }

        if (selectedParent instanceof Array) {
            selectedParent.forEach(row => this.deleteTableRowMain(row));
        } else {
            this.deleteTableRowMain(selectedParent);
        }
    }

    restoreTableRowMain = (selectedParent) => {
        if (!this.checkDeletedStatus(selectedParent['ModelState'])) return;

        const that = this;
        const index = this.findSelectedParentIndex(selectedParent);
        const parentDataSource = that.state.parentDataSource;

        selectedParent['ModelState'] = ModelState.Modified;
        parentDataSource[index] = selectedParent;

        this.setState({
            parentDataSource: parentDataSource
        });

        this.restoreCorrespondingChildren(selectedParent[this.state.linker]);
    }

    restoreTableRow = () => {
        const selectedParent = this.state.selectedParent;

        if (!selectedParent) return;

        if (selectedParent instanceof Array) {
            selectedParent.forEach(row => this.restoreTableRowMain(row));
        } else {
            this.restoreTableRowMain(selectedParent);
        }
    }

    refreshTable = (loadCallback) => {
        if (this.state.tableConfig.lazy) {
            const { sortField, sortOrder, rows, first } = this.parentTable.current.props;
            this.loadDataWithServerSidePagination({ SortName: sortField, SortOrder: sortOrder, rows, first }, loadCallback);
        } else {
            this.loadData(loadCallback);
        }
    }

    filter = (name, value, matchMode = "startsWith") => {
        this.parentTable.current.filter(value, name, matchMode);
    }

    //#endregion
    //#endregion

    //#region Sub-grid
    onSubGridEditorValueChange(props, value) {
        const rowData = props.rowData;
        rowData[props.field] = value;

        const childrenDataSource = this.state.childrenDataSource;
        const dataSourceConfig = this.getSubGridDSPosition(rowData);
        childrenDataSource[dataSourceConfig.hierarchicalPos] = rowData;

        switch (rowData['ModelState']) {
            case ModelState.Deleted:
            case ModelState.Modified:
            case ModelState.Added:
                break;
            default:
                rowData['ModelState'] = ModelState.Modified;
                break;
        }

        this.setState({ childrenDataSource: childrenDataSource });
    }

    subGridCheckboxEditor = (rowData, colProps) => {
        return <Checkbox checked={rowData[colProps.field]} onChange={(e) => this.onSubGridEditorValueChange(colProps, e.target.checked)} disabled={colProps.readonly} inputProps={{ style: colProps.style }} />;
    }

    subGridTextFieldEditor = (rowData, colProps) => {
        return <TextField type='text' value={rowData[colProps.field] ? rowData[colProps.field] : ''} onChange={(e) => this.onSubGridEditorValueChange(colProps, e.target.value)} disabled={colProps.disabled} InputProps={{ disableUnderline: colProps.disableUnderline, readOnly: colProps.readonly }} inputProps={{ style: colProps.style }} />;
    }

    subGridIntegerEditor = (rowData, colProps) => {
        return <TextField type='number' value={rowData[colProps.field] ? rowData[colProps.field] : ''} onChange={(e) => this.onSubGridEditorValueChange(colProps, e.target.value)} disabled={colProps.disabled} InputProps={{ disableUnderline: colProps.disableUnderline, readOnly: colProps.readonly }} inputProps={{ style: colProps.style }} />;
    }

    subGridDecimalEditor = (rowData, colProps) => {
        return <TextField type='number' value={rowData[colProps.field] ? rowData[colProps.field] : ''} onChange={(e) => this.onSubGridEditorValueChange(colProps, e.target.value)} disabled={colProps.disabled} InputProps={{ disableUnderline: colProps.disableUnderline, readOnly: colProps.readonly }} inputProps={{ style: colProps.style }} />;
    }

    subGridComboEditor = (rowData, colProps) => {
        return (
            <Select url={colProps.loader.url} withModule={colProps.loader.withModule} options={colProps.loader.options} value={rowData[colProps.field]} mapper={colProps.loader.mapper} onChange={(e) => this.onSubGridEditorValueChange(colProps, e.target.value)} disabled={colProps.readonly} />
        );
    }

    subGridDateEditor = (rowData, colProps) => {
        return (
            <DatePicker
                invalidDateMessage={null}
                value={rowData[colProps.field]}
                onChange={(dateValue) => this.onSubGridEditorValueChange(colProps, dateValue)}
                disabled={colProps.readonly}
                InputProps={{ disableUnderline: colProps.disableUnderline, readOnly: colProps.readonly }}
                inputProps={{ style: colProps.style }}
                format={this.dateFormat} />
        );
    }

    subGridTimeEditor = (rowData, colProps) => {
        return (
            <TimePicker
                invalidDateMessage={null}
                value={rowData[colProps.field]}
                onChange={(timeValue) => this.onSubGridEditorValueChange(colProps, timeValue)}
                disabled={colProps.readonly}
                InputProps={{ disableUnderline: colProps.disableUnderline, readOnly: colProps.readonly }}
                inputProps={{ style: colProps.style }} />
        );
    }

    getSubGridCellRenderer(type) {
        switch (type) {
            case 'text':
                return this.subGridTextFieldEditor;
            case 'int':
                return this.subGridIntegerEditor;
            case 'dec':
                return this.subGridDecimalEditor;
            case 'checkbox':
                return this.subGridCheckboxEditor;
            case 'date':
                return this.subGridDateEditor;
            case 'time':
                return this.subGridTimeEditor;
            case 'combo':
                return this.subGridComboEditor;
            default:
                return this.subGridTextFieldEditor;
        }
    }

    getSubGridDSPosition = (dataRow) => {
        var dataMatched = false,
            hierarchicalPos = 0;

        var childKey = this.state.childKey;

        this.state.childrenDataSource.forEach(function (childData) {
            if (dataMatched) return;

            if (childData[childKey] === dataRow[childKey]) {
                dataMatched = true;
            } else {
                hierarchicalPos++;
            }
        });

        return { dataMatched: dataMatched, hierarchicalPos: hierarchicalPos };
    }

    childRowClassName(rowData) {
        const rowEditorStatus = rowData.ModelState;
        const isDeleted = (rowEditorStatus === ModelState.Deleted);
        return isDeleted ? { 'deleted-row': true } : { 'restored-row': true };
    }

    renderChildren = (data) => {
        const dynamicColumns = this.state.subTableConfig.template.map((col) => {
            const colConf = { ...this.defaultColumnProps, ...col, editable: this.state.subTableConfig.editable || col.editable };

            return (
                <Column columnKey={colConf.columnKey} field={colConf.field} sortField={colConf.sortField} header={colConf.header} body={this.getSubGridCellRenderer(colConf.type)} loadingBody={colConf.loadingBody} footer={colConf.footer} sortable={colConf.sortable} sortFunction={colConf.sortFunction} filter={colConf.filter} filterMatchMode={colConf.filterMatchMode} filterPlaceholder={colConf.filterPlaceholder} filterType={colConf.filterType} filterMaxLength={colConf.filterMaxLength} filterElement={colConf.filterElement} filterFunction={colConf.filterFunction} style={colConf.style ? colConf.style : {}} className={colConf.className} headerStyle={colConf.headerStyle} headerClassName={colConf.headerClassName} bodyStyle={colConf.bodyStyle} bodyClassName={colConf.bodyClassName} footerStyle={colConf.footerStyle} footerClassName={colConf.footerClassName} expander={colConf.expander} frozen={colConf.frozen} selectionMode={colConf.selectionMode} colSpan={colConf.colSpan} rowSpan={colConf.rowSpan} editor={colConf.editor} editorValidator={colConf.editorValidator} editorValidatorEvent={colConf.editorValidatorEvent} onEditorSubmit={colConf.onEditorSubmit} onEditorCancel={colConf.onEditorCancel} excludeGlobalFilter={colConf.excludeGlobalFilter} rowReorder={colConf.rowReorder} rowReorderIcon={colConf.rowReorderIcon} key={colConf.field} customData={colConf.customData} disableUnderline={colConf.disableUnderline} readonly={!colConf.editable} />
            );
        });

        var filteredChildren = this.state.childrenDataSource.filter(child => child[this.state.linker].toString() === data[this.state.linker].toString());

        const {
            id, header, footer, style, className, tableStyle, tableClassName, paginator, paginatorPosition,
            alwaysShowPaginator, paginatorTemplate, additionalFooter, showAdd, showDelete, showRestore,
            paginatorRight, pageLinkSize, rowsPerPageOptions, currentPageReportTemplate, first, rows, totalRecords,
            lazy, sortField, sortOrder, multiSortMeta, sortMode, defaultSortOrder, emptyMessage, selectionMode, selection, onSelectionChange, contextMenuSelection, onContextMenuSelectionChange, compareSelectionBy, metaKeySelection, headerColumnGroup, footerColumnGroup, frozenHeaderColumnGroup, frozenFooterColumnGroup, responsive, resizableColumns, columnResizeMode, reorderableColumns, filters, globalFilter, scrollable, scrollHeight, virtualScroll, virtualScrollDelay,
            virtualRowHeight, frozenWidth, frozenValue, csvSeparator, exportFilename, rowGroupMode, autoLayout,
            rowClassName, rowGroupHeaderTemplate, rowGroupFooterTemplate, loading, loadingIcon, tabIndex, stateKey, stateStorage,
            onColumnResizeEnd, onSort, onPage, onFilter, onVirtualScroll, onRowClick, onRowDoubleClick, onRowSelect, onContextMenu, onColReorder, onRowReorder, onValueChange, editable
        } = this.state.subTableConfig;

        var currentChildTable =
            <DataTable ref={(el) => this.childrenTables[data[this.state.linker].toString()] = el} id={id} value={filteredChildren} header={header} footer={footer} style={style} className={className} tableStyle={tableStyle} tableClassName={tableClassName} paginator={paginator} paginatorPosition={paginatorPosition} alwaysShowPaginator={alwaysShowPaginator} paginatorTemplate={paginatorTemplate} paginatorLeft={(additionalFooter || showAdd || showDelete || this.state.tableConfig.subTableConfig || showRestore) && this.getPaginatorLeft('sub', data[this.state.linker])} paginatorRight={paginatorRight} pageLinkSize={pageLinkSize} rowsPerPageOptions={rowsPerPageOptions} currentPageReportTemplate={currentPageReportTemplate} first={first} rows={rows} totalRecords={totalRecords} lazy={lazy} sortField={sortField} sortOrder={sortOrder} multiSortMeta={multiSortMeta} sortMode={sortMode} defaultSortOrder={defaultSortOrder} emptyMessage={emptyMessage} selectionMode={selectionMode} selection={selection ? selection : this.state.selectedChild} onSelectionChange={onSelectionChange ? onSelectionChange : e => this.setState({ selectedChild: e.value })} contextMenuSelection={contextMenuSelection} onContextMenuSelectionChange={onContextMenuSelectionChange} compareSelectionBy={compareSelectionBy} dataKey={this.state.childKey} metaKeySelection={metaKeySelection} headerColumnGroup={headerColumnGroup} footerColumnGroup={footerColumnGroup} frozenHeaderColumnGroup={frozenHeaderColumnGroup} frozenFooterColumnGroup={frozenFooterColumnGroup} responsive={responsive} resizableColumns={resizableColumns} columnResizeMode={columnResizeMode} reorderableColumns={reorderableColumns} filters={filters} globalFilter={globalFilter} scrollable={scrollable} scrollHeight={scrollHeight} virtualScroll={virtualScroll} virtualScrollDelay={virtualScrollDelay} virtualRowHeight={virtualRowHeight} frozenWidth={frozenWidth} frozenValue={frozenValue} csvSeparator={csvSeparator} exportFilename={exportFilename} rowGroupMode={rowGroupMode} autoLayout={autoLayout} rowClassName={rowClassName ? rowClassName : this.childRowClassName} rowGroupHeaderTemplate={rowGroupHeaderTemplate} rowGroupFooterTemplate={rowGroupFooterTemplate} loading={loading} loadingIcon={loadingIcon} tabIndex={tabIndex} stateKey={stateKey} stateStorage={stateStorage} onColumnResizeEnd={onColumnResizeEnd} onSort={onSort} onPage={onPage} onFilter={onFilter} onVirtualScroll={onVirtualScroll} onRowClick={onRowClick} onRowDoubleClick={onRowDoubleClick} onRowSelect={onRowSelect} onContextMenu={onContextMenu} onColReorder={onColReorder} onRowReorder={onRowReorder} onValueChange={onValueChange} editable={editable}>
                {dynamicColumns}
                <Column field='ModelState' style={{ display: 'none' }} />
                <Column field='RowVersion' style={{ display: 'none' }} />
            </DataTable>;

        return (
            <div>
                <div className='content-section implementation'>
                    {currentChildTable}
                </div>
            </div>
        );
    }

    //#region CRUD
    addSubTableRow = () => {
        if (!this.state.subTableConfig.editable) return false;

        const sublinker = window.event.target.parentNode.parentNode.attributes.sublinker;
        if (!sublinker) return;

        const linkerVal = sublinker.value;

        var that = this;
        const newSubTableRow = {};

        this.state.subTableConfig.template.map(col => [col.field, col.type]).forEach(function (mapped) {
            switch (mapped[0]) {
                case that.state.childKey:
                    newSubTableRow[mapped[0]] = that.childKeyInitializer++;
                    break;
                case that.state.linker:
                    newSubTableRow[mapped[0]] = linkerVal;
                    break;
                default:
                    newSubTableRow[mapped[0]] = null;
                    break;
            }

            if (mapped[1] === 'checkbox') {
                newSubTableRow[mapped[0]] = false;
            }
        });

        newSubTableRow['ModelState'] = ModelState.Added;

        const childrenDataSource = this.state.childrenDataSource;
        childrenDataSource.push(newSubTableRow);

        this.setState({ childrenDataSource: childrenDataSource });
    }

    findSelectedChildIndex() {
        return this.state.childrenDataSource.indexOf(this.state.selectedChild);
    }

    // findIndexOfDeletingRowInChildTable(linkerVal) {
    //     var rows = this.childrenTables[linkerVal].table.rows;

    //     for (let i = 1; i < rows.length; i++) {
    //         if (rows[i].cells[this.childKeyPos].textContent.toString() === this.state.selectedChild[this.state.childKey].toString()) {
    //             return i;
    //         }
    //     }

    //     return -1;
    // }

    deleteSubTableRow = () => {
        if (!this.state.subTableConfig.editable) return false;

        const sublinker = window.event.target.parentNode.parentNode.attributes.sublinker;
        if (!sublinker) return;

        const linkerVal = sublinker.value;

        if (!this.state.selectedChild) return;
        if (this.state.selectedChild[this.state.linker].toString() !== linkerVal.toString()) return;

        const that = this;
        const index = this.findSelectedChildIndex();
        const childrenDataSource = this.state.childrenDataSource;
        const selectedChild = this.state.selectedChild;

        switch (this.state.selectedChild['ModelState']) {
            case ModelState.Deleted:
                break;
            case ModelState.Added:
                this.setState({
                    childrenDataSource: that.state.childrenDataSource.filter((val, i) => i !== index),
                    selectedChild: null
                });

                break;
            case ModelState.Modified:
                selectedChild['ModelState'] = ModelState.Deleted;
                childrenDataSource[index] = selectedChild;

                // this.childrenTables[linkerVal].table.rows[this.findIndexOfDeletingRowInChildTable(linkerVal)].style.color = 'red';

                this.setState({
                    childrenDataSource: childrenDataSource
                });

                break;
            default:
                selectedChild['ModelState'] = ModelState.Deleted;
                childrenDataSource[index] = selectedChild;

                // this.childrenTables[linkerVal].table.rows[this.findIndexOfDeletingRowInChildTable(linkerVal)].style.color = 'red';

                this.setState({
                    childrenDataSource: childrenDataSource
                });

                break;
        }
    }

    restoreSubTableRow = () => {
        const sublinker = window.event.target.parentNode.parentNode.attributes.sublinker;
        if (!sublinker) return;

        const linkerVal = sublinker.value;

        const selectedChild = this.state.selectedChild;
        if (!selectedChild) return;
        if (selectedChild[this.state.linker].toString() !== linkerVal.toString()) return;

        if (!this.checkDeletedStatus(selectedChild['ModelState'])) return;

        if (this.checkDeletedStatus(this.state.parentDataSource.find(parent => parent[this.state.linker].toString() === linkerVal.toString())['ModelState']))
            return;

        const index = this.findSelectedChildIndex();
        const childrenDataSource = this.state.childrenDataSource;

        selectedChild['ModelState'] = ModelState.Modified;
        childrenDataSource[index] = selectedChild;

        this.setState({
            childrenDataSource: childrenDataSource
        });
    }

    refreshSubTableRow = () => {

    }

    //#endregion
    //#endregion

    //#region Helper methods
    checkDeletedStatus(rowEditorStatus) {
        return ['Deleted', 'Delete'].find(status => status === rowEditorStatus);
    }

    //#endregion

    //#region Default
    defaultTableProps = {
        id: null,
        value: null,
        header: null,
        footer: null,
        style: null,
        className: null,
        tableStyle: null,
        tableClassName: null,
        paginator: true,
        paginatorPosition: 'bottom',
        alwaysShowPaginator: true,
        paginatorTemplate: 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown',
        paginatorLeft: null,
        paginatorRight: null,
        pageLinkSize: 5,
        rowsPerPageOptions: [5, 10, 20],
        currentPageReportTemplate: '({currentPage} of {totalPages})',
        first: 0,
        rows: 10,
        totalRecords: 0,
        lazy: false,
        sortField: null,
        sortOrder: null,
        multiSortMeta: null,
        sortMode: 'single',
        defaultSortOrder: 1,
        emptyMessage: null,
        selectionMode: 'single',
        selection: null,
        onSelectionChange: null,
        contextMenuSelection: null,
        onContextMenuSelectionChange: null,
        compareSelectionBy: 'deepEquals',
        dataKey: null,
        metaKeySelection: true,
        headerColumnGroup: null,
        footerColumnGroup: null,
        frozenHeaderColumnGroup: null,
        frozenFooterColumnGroup: null,
        rowExpansionTemplate: null,
        expandedRows: null,
        onRowToggle: null,
        responsive: true,
        resizableColumns: true,
        columnResizeMode: 'expand',
        reorderableColumns: false,
        filters: null,
        globalFilter: null,
        scrollable: true,
        scrollHeight: null,
        virtualScroll: false,
        virtualScrollDelay: 150,
        virtualRowHeight: 28,
        frozenWidth: null,
        frozenValue: null,
        csvSeparator: ',',
        exportFilename: 'download',
        rowGroupMode: null,
        autoLayout: false,
        rowClassName: null,
        rowGroupHeaderTemplate: null,
        rowGroupFooterTemplate: null,
        loading: false,
        loadingIcon: 'pi pi-spinner',
        tabIndex: '0',
        stateKey: null,
        stateStorage: 'session',
        onColumnResizeEnd: null,
        onSort: null,
        onPage: null,
        onFilter: null,
        onVirtualScroll: null,
        onRowClick: null,
        onRowDoubleClick: null,
        onRowSelect: null,
        onRowUnselect: null,
        onRowExpand: null,
        onRowCollapse: null,
        onContextMenu: null,
        onColReorder: null,
        onRowReorder: null,
        onValueChange: null,
        showAdd: false,
        showDelete: false,
        showRefresh: false,
        showRestore: false
    }

    defaultColumnProps = {
        columnKey: null,
        field: null,
        sortField: null,
        header: null,
        body: null,
        loadingBody: null,
        footer: null,
        sortable: false,
        sortFunction: null,
        filter: false,
        filterMatchMode: 'contains',
        filterPlaceholder: null,
        filterType: 'text',
        filterMaxLength: null,
        filterElement: null,
        filterFunction: null,
        style: null,
        className: null,
        headerStyle: null,
        headerClassName: null,
        bodyStyle: null,
        bodyClassName: null,
        footerStyle: null,
        footerClassName: null,
        expander: false,
        frozen: false,
        selectionMode: null,
        colSpan: null,
        rowSpan: null,
        editor: null,
        editorValidator: null,
        editorValidatorEvent: 'blur',
        onEditorSubmit: null,
        onEditorCancel: null,
        excludeGlobalFilter: false,
        rowReorder: false,
        rowReorderIcon: 'pi pi-bars',
        editable: true,
        disableUnderline: true
    }

    //#endregion
}
